<template>
    <v-container fill-height>
        <v-layout mt-5 justify-center>
            <v-flex xs12 sm8 md6 lg6 xl4>
                <v-card v-if="firebaseAuthLoaded">
                    <v-card-title primary-title>
                        <v-layout column>
                            <div class="title mb-2">Administration Login</div>
                            <v-divider></v-divider>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid">
                            <v-text-field
                                prepend-icon="person"
                                name="email"
                                label="Email"
                                type="email"
                                v-model="email"
                                v-bind:rules="emailRules"
                                required
                                data-cy="signinEmailField"
                            ></v-text-field>
                            <v-text-field
                                prepend-icon="lock"
                                name="password"
                                label="Password"
                                type="password"
                                data-cy="signinPasswordField"
                                v-model="password"
                                v-bind:rules="passwordRules"
                                required
                                v-on:keyup.enter="submit"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            flat
                            color="primary"
                            v-bind:disabled="!valid"
                            v-on:click="submit"
                            data-cy="signinSubmitBtn"
                        >Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'Signin',
    data() {
        return {
            valid: false,
            email: '',
            password: '',
            emailRules: [
                (v) => !!v || 'E-mail is required',
                (v) => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                (v) => !!v || 'Password is required',
                (v) => v.length >= 6 || 'Password must be greater than 6 characters'
            ]
        }
    },
    computed: {
        firebaseAuthLoaded() {
            return this.$store.state.firebaseAuthLoaded
        },
        isAuthenticated() {
            return this.$store.state.isAuthenticated
        },
        nextRoute() {
            return this.$route.query.redirect || '/'
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('userLogin', {
                    email: this.email,
                    password: this.password
                })
            }
        }
    },
    watch: {
        isAuthenticated(auth) {
            if (auth) {
                this.$router.replace(this.nextRoute)
            }
        }
    }
}
</script>

<style scoped></style>
